module.exports = __webpack_public_path__ + "static/media/pixels-and-print-logo.24f3e6b1.png";